import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Card, Table, Input, Button, Tooltip, Select, Tag } from 'antd'
import { req_page_ars_reservationTimeDivision } from '../../api'
import { usrRole } from '../../utils/dataUtil'
import { getDateYYYYMMDD } from '../../utils/dateUtil'
import {  SORT_FIELD_NAME, SORT_UP_DOWN } from '../../utils/contrains'

import './daily-quota-analysis.css'

class ConfigReservationdate extends Component {

    state = {
        loading: false,
        userLevel: 'NORMAL',
        item: {},
        // 分頁參數
        items: [],
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0
        },
        columnSort: SORT_FIELD_NAME,
        orderBy: SORT_UP_DOWN,
        searchField: 'ReservationDate',
        searchValue: getDateYYYYMMDD(new Date()),
        filterStatus: '',
        division: '日間部',
        
        domnloadFile: '',
        isShowModal: false
    }

    UNSAFE_componentWillMount() {
        this.init_columns()
    }

    componentDidMount() {
        this.api_page_items(1)
    }

    // 遠端數據處理 //////////////////////////////////////////////
    api_page_items = async (current) => {
        this.current = current // 保存當前頁，給其他方法可看到
        const { pageSize } = this.state.pagination
        const { searchField, searchValue, columnSort, orderBy, filterStatus, division } = this.state
        const { token, role, userCode } = this.props.user

        var userLevel = usrRole(role)
        this.setState({ userLevel: userLevel })

        this.setState({ loading: true })
        const result = await req_page_ars_reservationTimeDivision(userCode, userLevel, current, pageSize, columnSort, orderBy, searchField, searchValue, filterStatus, division, token)
        this.setState({ loading: false })

        //console.log(result)
        if (result.total > 0) {
            const { total } = result
            const items = result.data
            const pagination = { current: this.current, pageSize: this.state.pagination.pageSize, total }
            this.setState({ items, pagination })
            //console.log(this.state);
        } else {
            const items = []
            const pagination = { current: 1, pageSize: this.state.pagination.pageSize, total: 0 }
            this.setState({ items, pagination })
        }

    }

    // 數據配置設定 ////////////////////////////////////////////// 
    init_columns = () => {
        this.columns = [
            {
                title: '部別',
                dataIndex: 'Division',
                width: 30,
                responsive: ['md'],
                render: (text, item) => {
                    const { Id, Division } = item
                    let color = this.style_switch_color_tag('Division', Division)
                    return (
                        <Tag color={color} key={Id}>
                            <div>{text}</div>
                        </Tag>
                    )
                }
            },
            {
                title: '日期',
                dataIndex: 'ReservationDate',
                width: 35,
            },
            {
                title: '星期',
                dataIndex: 'ReservationWeek',
                width: 35,
                responsive: ['md'],
            },
            {
                title: '起訖',
                width: 40,
                render: (item) => {
                    const { ReservationEndTime, ReservationStartTime } = item
                    return (
                        <>
                            <span> {ReservationStartTime}</span> -
                            <span> {ReservationEndTime}</span>
                        </>
                    )
                }
            },
            {
                title: '配額',
                width: 35,
                render: (item) => {
                    const { ReservationTotal, ReservationLimitNumber } = item
                    return (
                        <>
                            <span> {ReservationTotal}</span> /
                            <span> {ReservationLimitNumber}</span>
                        </>
                    )
                }
            },

        ]
    }

    // 操作互動處理 //////////////////////////////////////////////   
    handle_page_size_change = (current, size) => {
        //console.log(size)
        this.setState({
            pagination: {
                current: current,
                pageSize: size
            }
        }, () => {
            this.api_page_items(current)
        })
    }

    handle_table_change = (pagination, filters, sorter, extra) => {
        if (filters) {
            const status = [...Object.values(filters).filter(Boolean)][0]
            if (status) {
                this.setState({ filterStatus: status }, () => {
                    this.api_page_items(pagination.current)
                });
            } else {
                this.setState({ filterStatus: '' }, () => {
                    this.api_page_items(pagination.current)
                });
            }
        } else {
            this.api_page_items(pagination.current)
        }
    }

    handle_data_refresh = () => {
        this.api_page_items(this.current)
    }

    style_switch_color_tag(column, param) {
        switch (column) {
                case 'Division':
                    switch (param) {
                        case '日間部':
                            return 'warning'
                        case '進修部':
                            return 'default'
                        default:
                            return 'default';
                    }
            default:
                break;
        }
    }

    /////////////////////////////////////////////////////////////     
    render() {
        const { loading, items, pagination, searchValue, division } = this.state
        const title = (
            <>
                <span>
                <Select value={division} style={{ width: 90 }} onChange={value => this.setState({ division: value })}>
                    <Select.Option value='日間部'>日間部</Select.Option>
                    <Select.Option value='進修部'>進修部</Select.Option>
                </Select>
                    <Input placeholder="日期" style={{ width: 150, margin: '0 5px' }} value={searchValue} onChange={event => this.setState({ searchValue: event.target.value })} />
                    <Button type='primary' onClick={() => this.api_page_items(1)}><i className="fas fa-search element-hidden"></i> 查詢</Button>
                    <Tooltip placement="top" title="重新整理"><Button type='primary' onClick={() => this.handle_data_refresh()}><i className="fas fa-sync-alt"></i></Button></Tooltip>
                </span>
            </>
        )
        return (
            <Card title={title}>
                <Table
                    bordered
                    scroll={{ y: 480 }}
                    loading={loading}
                    rowKey='KeyId'
                    dataSource={items}
                    onChange={this.handle_table_change}
                    rowClassName={(record, index) => (record.ReservationTotal > 0) ? (record.ReservationTotal >= record.ReservationLimitNumber ? "row-red" : "row-yellow") : ''}
                    pagination={{
                        ...pagination,
                        responsive: true,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: [5, 10, 20, 50, 100],
                        // onChange: this.api_page_applycase,
                        onShowSizeChange: this.handle_page_size_change
                    }}
                    columns={this.columns}
                />
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ConfigReservationdate)